<template>
  <div id="opdashboard" class="p-grid">
    <div class="p-col-6 p-offset-3"></div>
    <div>
      <Chart type="doughnut" class="p-shadow-8" :data="chartData" />
    </div>
    <br /><br /><br />
    <div>
      <Chart type="bar" class="p-shadow-8" :data="basicData" />
    </div>
    <br /><br />
    <Card class="p-shadow-8">
      <template slot="title"> % PMCS Completed </template>
      <template slot="content"> --% </template>
    </Card>

    <br /><br />

    <Card class="p-shadow-8">
      <template slot="title"> # NMC Equipment Reported </template>
      <template slot="content"> --- </template>
    </Card>
  </div>
</template>

<script>
import { fb_auth, fb_db } from "../firebase";
import Chart from "primevue/chart";
import Card from "primevue/card";
export default {
  name: "OpDashboard",
  components: {
    Chart,
    Card,
  },
  data() {
    return {
      servicedate: null,
      chartData: {
        labels: ["A", "B", "C"],
        datasets: [
          {
            data: [300, 50, 100],
            backgroundColor: ["#42A5F5", "#66BB6A", "#FFA726"],
            hoverBackgroundColor: ["#64B5F6", "#81C784", "#FFB74D"],
          },
        ],
      },
    };
  },
  basicData: {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "My First dataset",
        backgroundColor: "#42A5F5",
        data: [65, 59, 80, 81, 56, 55, 40],
      },
      {
        label: "My Second dataset",
        backgroundColor: "#FFA726",
        data: [28, 48, 40, 19, 86, 27, 90],
      },
    ],
  },
  methods: {
    logoutUser() {
      fb_auth
        .signOut()
        .then(() => {
          //sign-out successful.
          this.$router.push({ path: "/" });
        })
        .catch(function (error) {
          //an error happened
          console.log(error);
        });
    },
  },
  countDocs() {
    
fb_db.collection('faults').get()
  .then(snapshot => console.log(snapshot.size));
  }
};
</script>

<style lang="scss" scoped>
#dashboard {
  color: #999999;
}
</style>